import React, { useEffect, useState } from "react";
import ApiRequest from "../Common/restservice";
import { errorToast, successToast } from "../Common/showtoast";
import { useNavigate } from "react-router-dom";

function Profile() {
  const navigate = useNavigate();
  const [stateobj, setStateObj] = useState({});
  useEffect(() => {
    GetProfileDetails();
  }, []);
  useEffect(() => {
    console.log(stateobj);
  }, [stateobj]);
  const GetProfileDetails = async () => {
    let res = await ApiRequest("GetDashboardDetails.asp", "GET", null, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        navigate("/login");
      }
      return;
    }
    setStateObj(res);
  };
  const UpdateProfileDetails = async () => {
    // stateobj.account_number = stateobj.Account_Number;
    // stateobj.bank_name = stateobj.Bank_name;
    // stateobj.branch_name = stateobj.Branch_Name;
    // stateobj.ifsc = stateobj.IFSC;
    console.log(stateobj);
    let res = await ApiRequest("editprofile.asp", "POST", stateobj, {
      Authorization: localStorage.getItem("token"),
    });
    if (res.status === "error") {
      errorToast(res.message);
      if (res.message === "Session Expired") {
        localStorage.clear();
        navigate("/login");
      }
      return;
    }
    successToast(res.message);
    await GetProfileDetails();
  };
  return (
    <section className="content">
      <div className="row text-center">
        <div className="card overflow-hidden dash1-card border-0 ">
          <div className="card-body text-start">
            <h3 className=" mt-3 mb-3">Profile</h3>
            <div className="row">
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Username</h6>
                <div className="input-container">
                  <i className="las la-user inputicon"></i>
                  <input
                    type="search"
                    className=" form-control"
                    placeholder="Username"
                    aria-label="Username"
                    readOnly
                    value={stateobj.username}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Fullname</h6>
                <div className="input-container">
                  <i className="las la-user inputicon"></i>
                  <input
                    type="search"
                    className=" form-control"
                    placeholder="Fullname"
                    aria-label="Fullname"
                    onChange={(e) =>
                      setStateObj({ ...stateobj, fullname: e.target.value })
                    }
                    value={stateobj.fullname}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Mobile</h6>
                <div className="input-container">
                  <i className="las la-mobile inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="Mobile"
                    aria-label="Mobile"
                    readOnly
                    value={stateobj.mobile}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Email</h6>
                <div className="input-container">
                  <i className="las la-envelope inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="Email"
                    aria-label="Email"
                    readOnly
                    value={stateobj.email}
                  />
                </div>
              </div>

              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Nominee Name</h6>
                <div className="input-container">
                  <i className="las la-address-card inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="Nominee name"
                    value={stateobj.nominee}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        nominee: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Nominee Age</h6>
                <div className="input-container">
                  <i className="las la-address-card inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="Nominee age"
                    value={stateobj.nomineeage}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        nomineeage: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Nominee Relationship</h6>
                <div className="input-container">
                  <i className="las la-address-book inputicon"></i>
                  <select
                    className=" form-control"
                    value={stateobj.nomineerelationship}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        nomineerelationship: e.target.value,
                      });
                    }}
                  >
                    <option value={""}>
                      -- Select Nominee Relationship --
                    </option>
                    <option value={"Spouse"}>Spouse</option>
                    <option value={"Father"}>Father</option>
                    <option value={"Mother"}>Mother</option>
                    <option value={"Son"}>Son</option>
                    <option value={"Daughter"}>Daughter</option>
                    <option value={"Sister"}>Sister</option>
                    <option value={"Brother"}>Brother</option>
                  </select>
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Payee Name</h6>
                <div className="input-container">
                  <i className="las la-city inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="Payee Name"
                    value={stateobj.payeename}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        payeename: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Account Number</h6>
                <div className="input-container">
                  <i className="las la-map inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="Account Number"
                    value={stateobj.acno}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        acno: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Bank Name</h6>
                <div className="input-container">
                  <i className="las la-flag inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="Bank Name"
                    aria-label="Bank Name"
                    value={stateobj.bank_name}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        bank_name: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">UPI</h6>
                <div className="input-container">
                  <i className="las la-map-pin inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="UPI"
                    value={stateobj.upi}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        upi: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">IFSC</h6>
                <div className="input-container">
                  <i className="las la-map-pin inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="IFSC"
                    value={stateobj.ifsc}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        ifsc: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Account Type</h6>
                <div className="input-container">
                  <i className="las la-map-pin inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="Account Type"
                    value={stateobj.account_type}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        account_type: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
              <div className="col-lg-6 row mb-3">
                <h6 className="mb-1 ml-4">Branch Name</h6>
                <div className="input-container">
                  <i className="las la-map-pin inputicon"></i>
                  <input
                    type="text"
                    className=" form-control"
                    placeholder="Branch Name"
                    value={stateobj.branch_name}
                    onChange={(e) => {
                      setStateObj({
                        ...stateobj,
                        branch_name: e.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <button
              className="mx-auto mb-5 btn btn-primary"
              onClick={UpdateProfileDetails}
            >
              Update
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Profile;
